<template>
  <el-dialog class="el-dialogs" :append-to-body="true" title="知识模型详情" width="500px"
             :close-on-click-modal="false"
             :visible.sync="visible">
    <div v-if="this.selectData.sender" class="flex_l_c" style="margin-top: 10px;margin-bottom: 20px">
      <el-image
          class="profilePicture"
          :src="userInfo.image"
          :preview-src-list="[userInfo.image]"
          fit="fill"></el-image>
      <div class="usetName">{{ userInfo.name }}</div>
      <div class="ysttysps">分享给我的知识模型</div>
    </div>
    <div class="treeClass">
      <el-tree
          v-loading="loading"
          :data="data"
          :props="defaultProps"
          :default-expand-all="true"
      ></el-tree>
    </div>
    <div slot="footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="this.selectData.sender" @click="saveData()">保存为我的知识模型
      </el-button>
    </div>
    <save-data-my ref="saveDataMy" @saveSuccess="saveSuccess"></save-data-my>
  </el-dialog>
</template>

<script>
import SaveDataMy from "@/views/modules/academic/academic/learningNode/saveDataMy.vue";

export default {
  name: "learningDetail",
  components: {SaveDataMy},
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'nodeName'
      },
      selectData: {},
      userInfo: {},
    };
  },

  methods: {
    init(row) {
      this.selectData = row
      this.visible = true
      this.getDetail(row)
    },

    getDetail(row) {
      this.loading = true
      this.$axios(this.api.academic.knowledgemodelGetById + row.id, {}).then(res => {
        if (res && res.status) {
          this.$axios(this.api.academic.knowledgemodelnodeGetByKnowledgeModelId + row.id, {}).then(data => {
            if (data && data.status) {
              this.data = [
                {
                  id: '',
                  nodeName: res.data.modelName,
                  children: [],
                }
              ]
              this.data[0].children = data.data
              this.loading = false
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
      if (row.sender) {
        this.$axios(this.api.user.getUserRoleInfo + '/' + row.sender, {}).then(data => {
          if (data.status) {
            this.userInfo = data.data
          }
        })
      }
    },

    saveData() {
      let row = {
        id: this.selectData.id,
        modelName: this.data[0].nodeName,
      }
      this.$refs.saveDataMy.init(row)
    },

    saveSuccess() {
      this.$confirm('已保存到【知识模型管理】，是否现在查看？', '保存成功！', {
        confirmButtonText: '去查看',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          path:'/academic/academic/learningModel',
          query:{
            type:Math.random()
          }
        })
        this.visible = false
        this.$emit('refreshList')
      })
    },
  },
}
</script>

<style scoped>
.treeClass {
  height: 350px;
}

.profilePicture {
  margin-left: 15px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.usetName {
  padding-left: 10px;
  font-weight: bold;
}

.ysttysps {
  font-size: 13px;
  padding-left: 15px;
}
</style>